import React from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { BACKGROUND_COLOR, BLACK_COLOR, WHITE_COLOR, V2_BACKGROUND_COLOR, V2_ACTIVE_COLOR, V2_BUTTON_COLOR, V2_POINT_COLOR, V2_LOGO_COLOR, V2_INACTIVE_COLOR } from "../config/color";
import logo from "../assets/image/Treasurer.png";
import GAEvent from '../utils/googleAnalytics';
import { getItem, removeItem } from "../utils/handleStorage";
import _ from "lodash";

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: ${V2_BACKGROUND_COLOR}; */
  background-color: white;
  @media (max-width: 768px) {
    height: 80px;
  }
`;

const AllList = styled.ul`
  justify-content: space-between;
  /* justify-content: flex-start; */
  width: 1104px;
  align-items: center;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`;

const Item = styled.li`
  text-align: center;
  @media (max-width: 768px) {
    height: 80px;
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${Item} {
    margin-right: 40px;
    color: ${V2_ACTIVE_COLOR};

    @media (max-width: 768px) {
      margin-right: 12px;
    }

    &:is(:last-child) {
      margin-right: 0px;
    }
  }

`;



const SLink = styled(Link)`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  /* color: ${props => (props.current ? `${V2_POINT_COLOR}` : `${V2_INACTIVE_COLOR}`)}; */
  font-size: 14px;
  transition: border-bottom 0.5s ease-in-out;
  @media (max-width: 768px) {
    font-size: 12px;
    height: 80px;
    border-bottom-width: 2px;
  }
`;

const ButtonLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  /* color: ${props => (props.current ? `${V2_POINT_COLOR}` : `${V2_INACTIVE_COLOR}`)}; */
  color: white;
  font-size: 14px;
  transition: border-bottom 0.5s ease-in-out;
  
  /* background-color: ${V2_BUTTON_COLOR}; */
  @media (max-width: 768px) {
    font-size: 12px;
    height: 80px;
    border-bottom-width: 2px;
  }
  
  p {
    padding: 12px 16px;
    background-color: ${V2_BUTTON_COLOR};
    
    border-radius: 14px;
  }
`;

const Image = styled.img`
  width: 80px;
  @media (max-width: 768px) {
    width: 90px;
  }
`;

export default withRouter(({ location: { pathname } }) => {
  const session = getItem('session');

  const _targetLink  = (url) => {
    window.open(url, '_blank');
    GAEvent('Link', '웹사이트', '얼마야');
  }

  return (
    <>
    {(pathname === '/signin' || pathname === '/signup' || pathname === '/shop/profile') ? (
        null
      ) : (
        <Header>
          <AllList>
            <Item>
              <SLink
                to="/"
                style={{
                  border: "none",
                  justifyContent: "flex-start",
                  color: `${V2_LOGO_COLOR}`
                }}
              >
                <Image src={logo} alt="logo" />
              </SLink>
            </Item>
            {/* <List>
              <Item>
                <SLink style={{color: `${V2_BUTTON_COLOR}`}} onClick={() => {window.open('https://ulmaya.zikto.com/', '_blank')}}>
                  얼마야
                </SLink>
              </Item>
              <Item>
                <SLink>
                  시계
                </SLink>
              </Item>
            </List> */}
            {!_.isNil(session) ? (
              <List>
                <Item>
                  <SLink style={{color: `${V2_BUTTON_COLOR}`}} onClick={() => _targetLink('https://ulmaya.zikto.com/')}>
                    얼마야
                  </SLink>
                </Item>
                <Item>
                  <SLink style={{color: 'rgba(0,0,0,0.2)'}} to="/partners">
                    파트너스
                  </SLink>
                </Item>
                <Item>
                  <SLink onClick={() => removeItem('session')}>
                    로그아웃
                  </SLink>
                </Item>
                <Item>
                  <ButtonLink to="/shop/profile">
                    <p>
                      프로필
                    </p>
                  </ButtonLink>
                </Item>
              </List>
            ) : (
              <List>
                <Item>
                  <SLink style={{color: `${V2_BUTTON_COLOR}`}} onClick={() => _targetLink('https://ulmaya.zikto.com/')}>
                    얼마야
                  </SLink>
                </Item>
                <Item>
                  <SLink style={{color: 'rgba(0,0,0,0.2)'}} to="/partners">
                    파트너스
                  </SLink>
                </Item>
                <Item>
                  <SLink to="/signin">
                    로그인
                  </SLink>
                </Item>
                <Item>
                  <ButtonLink to="/signup">
                    <p>
                      회원가입
                    </p>
                  </ButtonLink>
                </Item>
              </List>
            )}
          </AllList>
        </Header>
    )}
    </>
  );
});
